import { render, staticRenderFns } from "./NewRequestView.vue?vue&type=template&id=f8b2eb1a"
import script from "./NewRequestView.vue?vue&type=script&lang=js"
export * from "./NewRequestView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports